<script>
  import { createEventDispatcher } from "svelte";

  export let placeholder = "Search...";
  // Bindable so a parent can clear the field, e.g. when it resets its filters
  export let value = "";
  const dispatch = createEventDispatcher();

  function handleInput(event) {
    dispatch("search", event.target.value);
  }
</script>

<div class="search-input">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M23.3962 24L13.8113 14.4151C13.0665 15.0963 12.198 15.6125 11.2056 15.9637C10.2133 16.3149 9.23278 16.4906 8.26415 16.4906C5.95441 16.4906 3.99962 15.6939 2.39977 14.1005C0.799924 12.5071 0 10.5574 0 8.25144C0 5.94545 0.796692 3.99371 2.39008 2.39623C3.98348 0.798742 5.93031 0 8.23057 0C10.5308 0 12.4888 0.797296 14.1046 2.39189C15.7204 3.98645 16.5283 5.93492 16.5283 8.23728C16.5283 9.26149 16.3396 10.2704 15.9623 11.2642C15.5849 12.2579 15.0692 13.1069 14.4151 13.8113L24 23.3585L23.3962 24ZM8.26415 15.6604C10.3543 15.6604 12.1158 14.9497 13.5488 13.5283C14.9817 12.1069 15.6981 10.3459 15.6981 8.24528C15.6981 6.14465 14.9817 4.38365 13.5488 2.96226C12.1158 1.54088 10.3543 0.830189 8.26415 0.830189C6.17401 0.830189 4.41248 1.54088 2.97955 2.96226C1.54664 4.38365 0.830189 6.14465 0.830189 8.24528C0.830189 10.3459 1.54664 12.1069 2.97955 13.5283C4.41248 14.9497 6.17401 15.6604 8.26415 15.6604Z"
      fill="#1C1C20"
    />
  </svg>
  <input
    autocomplete="off"
    type="search"
    {placeholder}
    bind:value
    on:input={handleInput}
  />
</div>

<style>
  .search-input {
    display: flex;
    gap: 2px;
    align-items: center;
    border-radius: 5px;
    border: 1px solid rgba(40, 40, 40, 0.25);
    background: var(--pax-white);
    overflow: hidden;
    padding: 4px 12px;
  }
  input {
    outline: none;
    border: none;
    color: rgba(40, 40, 40, 0.5);
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    display: flex;
    align-items: center;
  }
  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    height: 14px;
    width: 14px;
    margin-right: 12px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%231C1C20' stroke-width='2'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E")
      center/contain no-repeat;
    cursor: pointer;
  }
</style>
